module.exports = __webpack_public_path__ + "static/media/009.74ab6aa6.jpg";